import { FC, PropsWithChildren } from 'react';
import styled from 'styled-components';
import { FlexSpacer } from 'ui/flexSpacer';
import { Skeleton } from 'ui/skeleton';
import { colors, Overline } from 'ui/theme';

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: ${colors.secondaryText};
`;

type ModuleHeaderProps = {
  title: string;
  isLoading?: boolean;
};

export const ModuleHeader: FC<PropsWithChildren<ModuleHeaderProps>> = ({
  title,
  children,
  isLoading = false,
  ...props
}) => {
  return (
    <Header {...props}>
      {isLoading ? (
        <FlexSpacer height={32}>
          <Skeleton width={94} height={16} isRound />
        </FlexSpacer>
      ) : (
        <Overline>{title}</Overline>
      )}
      {children}
    </Header>
  );
};
